import BaseRepository from './BaseRepository';

export default class ReservationsRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'v1/reservations';
    }

    searchForMember(term, query, includes = [])
    {
        const queryString = this.buildQueryString({
            ...query,
            includes,
        });

        return this.request('GET', `${this.getEndpoint()}/search/${term}?${queryString}`);
    }

    getPendingPayments(includes)
    {
        const queryString = this.buildQueryString({
            includes,
        });
        return this.request('GET', `${this.getEndpoint()}/pending-payments?${queryString}`);
    }

    setComponentMembers(reservationId, data)
    {
        return this.request('POST', `${this.getEndpoint()}/${reservationId}/component-members`, data);
    }

    addInformativeService(reservationId, data)
    {
        return this.request('POST', `${this.getEndpoint()}/${reservationId}/add-informative-service`, data);
    }

    addInformativeHotel(reservationId, data)
    {
        return this.request('POST', `${this.getEndpoint()}/${reservationId}/add-informative-hotel`, data);
    }

    updateInformativeHotel(reservationId, reservationServiceId, data)
    {
        return this.request('PATCH', `${this.getEndpoint()}/${reservationId}/update-informative-hotel/${reservationServiceId}`, data);
    }

    addInformativeFlight(reservationId, data)
    {
        return this.request('POST', `${this.getEndpoint()}/${reservationId}/add-informative-flight`, data);
    }
}
